<template>
    <main
        :style="style"
        class="rkm-main"
    >
        <div class="rkm-main-wrap">
            <slot />
        </div>
    </main>
</template>

<script>
export default {
    computed: {
        style() {
            return {
                paddingLeft: this.open ? `256px` : '0px',
            }
        },
    },
    props: {
        open: {type: Boolean},
    },
}
</script>

<style scoped>
.rkm-main {
    display: flex;
    flex: 1 0 auto;
    padding-top: 50px;
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.rkm-main-wrap {
    flex: 1 1 auto;
    position: relative;
}
</style>